export default "__VITE_ASSET__BiS3rEnq__"